import { render } from "./our_brands.vue?vue&type=template&id=22647c78"
import script from "./our_brands.vue?vue&type=script&lang=js"
export * from "./our_brands.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__